module.exports = __webpack_public_path__ + "static/vroom-80e98888105a0a29fc5f1617cfbee63e.jpeg";